/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createInvitedListStyles = makeStyles(() => ({
  root: {
    marginBottom: '32px',
    width: '100%',
    maxWidth: '800px',
  },
  firstTableCell: {
    width: '42%',
  },
  cancelButton: {
    minWidth: '120px',
    textTransform: 'none',
    padding: '10px 20px',
    fontSize: '14px',
    marginLeft: 'auto',
  },
  cancelCell: {
    padding: '0',
  },
}));
